/**
 * ISO 639-1 English language names — static fallback when REST Countries
 * is unreachable. Mirrors how COUNTRIES are shipped client-side (no DB).
 */
export const WORLD_LANGUAGES = [
    'Abkhazian',
    'Afar',
    'Afrikaans',
    'Akan',
    'Albanian',
    'Amharic',
    'Arabic',
    'Aragonese',
    'Armenian',
    'Assamese',
    'Avaric',
    'Avestan',
    'Aymara',
    'Azerbaijani',
    'Bambara',
    'Bashkir',
    'Basque',
    'Belarusian',
    'Bengali',
    'Bihari',
    'Bislama',
    'Bosnian',
    'Breton',
    'Bulgarian',
    'Burmese',
    'Catalan',
    'Chamorro',
    'Chechen',
    'Chichewa',
    'Chinese',
    'Church Slavic',
    'Chuvash',
    'Cornish',
    'Corsican',
    'Cree',
    'Croatian',
    'Czech',
    'Danish',
    'Divehi',
    'Dutch',
    'Dzongkha',
    'English',
    'Esperanto',
    'Estonian',
    'Ewe',
    'Faroese',
    'Fijian',
    'Finnish',
    'French',
    'Western Frisian',
    'Fulah',
    'Galician',
    'Georgian',
    'German',
    'Greek',
    'Guarani',
    'Gujarati',
    'Haitian Creole',
    'Hausa',
    'Hebrew',
    'Herero',
    'Hindi',
    'Hiri Motu',
    'Hungarian',
    'Interlingua',
    'Indonesian',
    'Interlingue',
    'Irish',
    'Igbo',
    'Inupiaq',
    'Ido',
    'Icelandic',
    'Italian',
    'Inuktitut',
    'Japanese',
    'Javanese',
    'Kalaallisut',
    'Kannada',
    'Kanuri',
    'Kashmiri',
    'Kazakh',
    'Khmer',
    'Kikuyu',
    'Kinyarwanda',
    'Kirghiz',
    'Komi',
    'Kongo',
    'Korean',
    'Kurdish',
    'Kuanyama',
    'Latin',
    'Luxembourgish',
    'Ganda',
    'Limburgish',
    'Lingala',
    'Lao',
    'Lithuanian',
    'Luba-Katanga',
    'Latvian',
    'Manx',
    'Macedonian',
    'Malagasy',
    'Malay',
    'Malayalam',
    'Maltese',
    'Maori',
    'Marathi',
    'Marshallese',
    'Mongolian',
    'Nauru',
    'Navajo',
    'North Ndebele',
    'Nepali',
    'Ndonga',
    'Norwegian Bokmål',
    'Norwegian Nynorsk',
    'Norwegian',
    'Sichuan Yi',
    'South Ndebele',
    'Occitan',
    'Ojibwa',
    'Church Slavonic',
    'Oromo',
    'Oriya',
    'Ossetian',
    'Punjabi',
    'Pali',
    'Persian',
    'Polish',
    'Pashto',
    'Portuguese',
    'Quechua',
    'Romansh',
    'Rundi',
    'Romanian',
    'Russian',
    'Sanskrit',
    'Sardinian',
    'Sindhi',
    'Northern Sami',
    'Samoan',
    'Sango',
    'Serbian',
    'Gaelic',
    'Shona',
    'Sinhala',
    'Slovak',
    'Slovenian',
    'Somali',
    'Southern Sotho',
    'Spanish',
    'Sundanese',
    'Swahili',
    'Swati',
    'Swedish',
    'Tamil',
    'Telugu',
    'Tajik',
    'Thai',
    'Tigrinya',
    'Tibetan',
    'Turkmen',
    'Tagalog',
    'Tswana',
    'Tonga',
    'Turkish',
    'Tsonga',
    'Tatar',
    'Twi',
    'Tahitian',
    'Uighur',
    'Ukrainian',
    'Urdu',
    'Uzbek',
    'Venda',
    'Vietnamese',
    'Volapük',
    'Walloon',
    'Welsh',
    'Wolof',
    'Xhosa',
    'Yiddish',
    'Yoruba',
    'Zhuang',
    'Zulu',
    // Common travel / destination names not always in ISO common list
    'Dhivehi',
    'Filipino',
    'Cantonese',
    'Mandarin',
    'Sign Language',
].sort((a, b) => a.localeCompare(b));
